export default __webpack_public_path__ + "static/media/1.400b3630.png";